import { Decrement, Increment, Input } from './components'
import { NumberInput as Root } from './NumberInput'

export const NumberInput = {
  Root,
  Input,
  Increment,
  Decrement
}
